import { PaymentHeader } from './PaymentHeader';

export default PaymentHeader;
